export type SunriseSunsetConditionUI = {
	type: 'sunrise' | 'sunset';
	beforeAfter: 'before' | 'after';
	hours: number;
	mins: number;
	locid: number | string;
};

export function is_sunrise_sunset_condition_ui(o: any): o is SunriseSunsetConditionUI {
	return (
		typeof o === 'object' &&
		['sunrise', 'sunset'].includes(o.type) &&
		['before', 'after'].includes(o.beforeAfter) &&
		typeof o.hours === 'number' &&
		typeof o.mins === 'number'
	);
}
